import { InteractionReason } from '@backoffice-frontend/graphql'
import {
  FormField,
  FormFieldValidation,
  Input,
  Option,
  Select,
} from '@moia-dev/pace-web'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getVehicleInteractionReasonLabel } from '../../locales/mappings'

const DEPRECATED_INTERACTION_REASONS: InteractionReason[] = [
  InteractionReason.Cleaning,
]

export const VehicleReasonSelection = ({
  handleReasonSelect,
  isEmergency,
}: {
  handleReasonSelect: (
    reason: InteractionReason,
    reasonFreeText: string | undefined,
  ) => void
  isEmergency: boolean
}) => {
  const [selectedReason, setSelectedReason] = useState<
    InteractionReason | undefined
  >(undefined)
  const { t } = useTranslation()

  const MAX_DESCRIPTION_LENGTH = 50

  const [descriptionText, setDescriptionText] = useState('')

  const isMaxLength = descriptionText.length >= MAX_DESCRIPTION_LENGTH

  const reasons: InteractionReason[] = useMemo(
    () =>
      isEmergency
        ? [
            InteractionReason.AppProblems,
            InteractionReason.TelemetryProblems,
            InteractionReason.Other,
          ]
        : Object.values(InteractionReason).filter(
            reason => !DEPRECATED_INTERACTION_REASONS.includes(reason),
          ),
    [isEmergency],
  )

  return (
    <div>
      <FormField
        label={t('vehicleCommon_interactionDialog_reasonSelection_subtitle')}
      >
        <Select<InteractionReason | undefined>
          value={selectedReason}
          placeholder={t(
            'vehicleCommon_interactionDialog_reasonSelection_placeholder',
          )}
          onChange={reason => {
            if (!reason) return
            setSelectedReason(reason)
            handleReasonSelect(reason, descriptionText)
          }}
          renderValue={reason =>
            reason ? getVehicleInteractionReasonLabel(t, reason) : undefined
          }
          options={reasons.map(reason => (
            <Option key={reason} value={reason}>
              {getVehicleInteractionReasonLabel(t, reason)}
            </Option>
          ))}
        />
      </FormField>
      {selectedReason === InteractionReason.Other && (
        <div onKeyDown={e => e.stopPropagation()} css={{ marginTop: 16 }}>
          <FormField
            label={t('vehicleCommon_interactionDialog_description_label')}
            maxLength={MAX_DESCRIPTION_LENGTH}
            value={descriptionText}
            caption={
              !isMaxLength &&
              t('vehicleCommon_interactionDialog_description_charactersLeft', {
                charCount: MAX_DESCRIPTION_LENGTH - descriptionText.length,
              })
            }
            validation={
              isMaxLength && (
                <FormFieldValidation type="error">
                  {t('vehicleCommon_interactionDialog_descriptionHelperText')}
                </FormFieldValidation>
              )
            }
          >
            <Input
              maxLength={MAX_DESCRIPTION_LENGTH}
              error={isMaxLength}
              placeholder={t(
                'vehicleCommon_interactionDialog_description_label',
              )}
              value={descriptionText}
              onChange={e => {
                setDescriptionText(e.target.value)
                if (selectedReason) {
                  handleReasonSelect(selectedReason, e.target.value)
                }
              }}
            />
          </FormField>
        </div>
      )}
    </div>
  )
}
